import $ from 'jquery';
//window.$ = window.jQuery = $;

import "@popperjs/core";
require('bootstrap');
require('slick-carousel');

import './scripts/menu';
import './scripts/front-page';
import './scripts/needs-survey';
import './scripts/ressources';
import './scripts/about-us';
import './scripts/actualites';
import './scripts/single-slider-media';
import './scripts/offres';
import './scripts/partenaires';
import './scripts/cas-clients';
import './scripts/contact';
import './scripts/search';
import './scripts/offres-single';
import './scripts/search-job-list';
import './scripts/single-job';
import './scripts/recrutement';
import './scripts/vie-jems';
import './scripts/navigation';
import './scripts/filter';
import './scripts/stop-vids';
import './scripts/contact-scrolly.js';



